import { notification } from "antd/lib";
import {
  createUserAccountService,
  changeEmail,
  refreshToken,
} from "../../services/userService";
import {
  CREATE_USER_ACCOUNT,
  CHANGE_EMAIL,
  REFRESH_TOKEN,
} from "../actionTypes";
import store from "store";

export const createUserAccountAction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_USER_ACCOUNT, payload: { loading: true } });
    const { data: body } = await createUserAccountService(payload);

    const { status, message, data } = body;

    if (status === 201) {
      notification.success({
        message: "Success",
        description: "User Account has been created",
      });
      dispatch({
        type: CREATE_USER_ACCOUNT,
        payload: {
          loading: false,
          status: "success",
          message,
          data,
        },
      });
    } else {
      dispatch({
        type: CREATE_USER_ACCOUNT,
        payload: { loading: false, status: "error" },
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_USER_ACCOUNT,
      payload: { loading: false, status: "error" },
    });
  }
};

export const changeEmailAction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CHANGE_EMAIL, payload: { loading: true } });
    const { data: body } = await changeEmail(payload);

    const { status, message, data } = body;

    if (status === 200) {
      notification.success({
        message: "Success",
        description: body.message,
      });
      dispatch({
        type: CHANGE_EMAIL,
        payload: {
          loading: false,
          status: "success",
          message,
          data,
        },
      });
    } else {
      dispatch({
        type: CHANGE_EMAIL,
        payload: { loading: false, status: "error" },
      });
    }
  } catch (error) {
    dispatch({
      type: CHANGE_EMAIL,
      payload: { loading: false, status: "error" },
    });
  }
};

export const refreshTokenAction = (redirectUrl) => async (dispatch) => {
  try {
    dispatch({ type: REFRESH_TOKEN, payload: { loading: true } });
    const { data: body } = await refreshToken();

    const { status, message, data } = body;

    if (status === 200) {
      dispatch({
        type: REFRESH_TOKEN,
        payload: {
          loading: false,
          status: "success",
          message,
          data,
        },
      });
      store.set("token", data.token);
      if(redirectUrl){
      window.location.href = redirectUrl;
    }
    } else {
      dispatch({
        type: REFRESH_TOKEN,
        payload: { loading: false, status: "error" },
      });
    }
  } catch (error) {
    dispatch({
      type: REFRESH_TOKEN,
      payload: { loading: false, status: "error" },
    });
  }
};
